export default __webpack_public_path__ + "assets/images/43fe9ddfc6984bc2561d41d532454642.jpg";